

















import Vue from 'vue'
import { db } from '@/firebase'
import { BlogPost } from '@/types'
import { convertDataFromApi } from '@/utils'

interface PostPageData {
    post?: BlogPost
}

export default Vue.extend({
    name: 'PostPage',
    computed: {
        slug() {
            const entries = this.$route.path.split('/')
            return entries[entries.length - 1]
        },
        dateString() {
            const options = { year: 'numeric', month: 'long', day: 'numeric' }
            return this.post?.date ? this.post.date.toLocaleDateString(this.$i18n.locale, options) : ''
        },
    },
    data: (): PostPageData => ({
        post: undefined,
    }),
    mounted() {
        db.collection('fl_content')
            .where('slug', '==', this.slug)
            .limit(1)
            .get()
            .then((snapshot) => {
                const doc = snapshot.docs[0]
                if (doc) {
                    this.post = convertDataFromApi(doc.data(), false) as BlogPost
                } else {
                    this.$router.push('NotFound')
                }
            })
            .catch((err) => {
                console.log(err)
                this.$router.push('NotFound')
            })
    },
})
